<div class="bookingWaitingPage__section--productDates">
  <app-ds-icon
    [icon]="icon.Calendar"
    [size]="iconSize"
    [color]="iconColor.Primary">
  </app-ds-icon>
  <ng-container *ngIf="!isByhours; else sectionByhours">
    <div class="bookingWaitingPage__sectionCont">
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="startDate | date: 'EE, d MMM' | dateFormat | titlecase">
        </app-ds-typography>
        <ng-container *ngIf="endDate">
          <app-ds-typography
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="endDate | date: 'EE, d MMM' | dateFormat | titlecase">
          </app-ds-typography>
        </ng-container>
      </div>
      <div class="box" *ngIf="showLengthOfStay">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="totalNightsNumber + ' ' + (nights | transloco)">
        </app-ds-typography>
      </div>
    </div>
  </ng-container>
  <ng-template #sectionByhours>
    <div class="bookingWaitingPage__sectionCont">
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="startDate | date: 'EE, d MMM' | dateFormat | titlecase">
        </app-ds-typography>
      </div>
      <div class="box">
        <app-ds-typography
        [size]="fontSize.XXS"
        [color]="fontColor.Secondary"
        [fontFamily]="fontFamily.Regular"
        [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.HOURS'| transloco: { hours: packHours }">
      </app-ds-typography>
      </div>
    </div>
  </ng-template>
</div>

<div class="bookingWaitingPage__section--productSmallDetail" *ngIf="(smallDetail$ | async)?.length">
  <app-ds-icon
    [icon]="smallDetailIcon"
    [size]="iconSize"
    [color]="iconColor.Primary">
  </app-ds-icon>
  <div class="bookingWaitingPage__sectionCont">
    <div class="box">
      <ng-container *ngFor="let detailItem of smallDetail$ | async">
        <p [innerHTML]="detailItem"></p>
      </ng-container>
    </div>
  </div>
</div>

<div class="bookingWaitingPage__section--productTravelers" *ngIf="travelers.length">
  <app-ds-icon
    [icon]="icon.PersonOutline"
    [size]="iconSize"
    [color]="iconColor.Primary">
  </app-ds-icon>
  <div class="bookingWaitingPage__sectionCont">
    <div class="box">
      <ng-container *ngIf="showTravelerQuantityDetail">
        <p *ngIf="!isByhours; else quantityTravelerByhours" class="traveler-quantity-detail">
          <app-ds-typography
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="'USER_HISTORY_MODULE.DETAIL.PASSENGERS.' + getAdultsTranslate | transloco: { quantity: adults } ">
          </app-ds-typography>
          <app-ds-typography
            *ngIf="childrens"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="'USER_HISTORY_MODULE.DETAIL.PASSENGERS.' + getChildrenTranslate | transloco: { quantity: childrens }">
          </app-ds-typography>
        </p>
        <ng-template #quantityTravelerByhours>
          <p class="traveler-quantity-detail">
            <app-ds-typography
              [size]="fontSize.XXS"
              [color]="fontColor.Primary"
              [fontFamily]="fontFamily.Regular"
              [text]="'USER_HISTORY_MODULE.DETAIL.PASSENGERS.' + getGuestsTranslate | transloco: { quantity: capacity }">
            </app-ds-typography>
          </p>
        </ng-template>
      </ng-container>
      <ng-container *ngFor="let traveler of travelers">
        <app-ds-typography
          *ngIf="!hiddenTraveler(traveler)"
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="traveler.FirstName + ' ' + traveler.LastName">
        </app-ds-typography>
      </ng-container>
    </div>
  </div>
</div>